import { isEmpty, uniqueId } from 'lodash/fp';
import i18next from 'i18next';
import { TIMEOUT, UNEXPECTED_FAILURE } from 'app/store/__generated__/errors';
import { ErrorLevel } from 'app/lib/constants';
import { translateError } from 'app/lib/error';

export const getShareError = (share) => {
    const error = share?.lastRunError;
    if (isEmpty(error)) {
        return [];
    }

    let message;

    if (error.code === UNEXPECTED_FAILURE && error.message.includes('Timeout')) {
        message = i18next.t(`errors:Shares.${share.type}.${TIMEOUT}`, {
            shareId: share.id
        });
    } else if (error.code === UNEXPECTED_FAILURE) {
        message = i18next.t(`errors:Shares.${share.type}.${UNEXPECTED_FAILURE}`, {
            shareId: share.id
        });
    } else {
        message = translateError(i18next.t, { ...error, _type: error.code });
    }

    return [
        {
            id: uniqueId('share_'),
            type: 'GENERIC_ERROR',
            level: ErrorLevel.ERROR,
            values: { message }
        }
    ];
};
